import { render, staticRenderFns } from "./inviteFriendsComp.vue?vue&type=template&id=5f882eb0&scoped=true"
import script from "./inviteFriendsComp.vue?vue&type=script&lang=js"
export * from "./inviteFriendsComp.vue?vue&type=script&lang=js"
import style0 from "./inviteFriendsComp.vue?vue&type=style&index=0&id=5f882eb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f882eb0",
  null
  
)

export default component.exports